import { render } from "./Snow.vue?vue&type=template&id=bef35df6&ts=true"
import script from "./Snow.vue?vue&type=script&lang=ts"
export * from "./Snow.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__